import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

// Lightweight one-shot notification (in-page, no service worker). Used right after booking submit.
export async function requestNotificationPermission() {
  if (typeof window === "undefined" || !("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
}

export function sendLocalNotification(title, body, tag = "cgmt-booking") {
  if (typeof window === "undefined" || !("Notification" in window)) return false;
  if (Notification.permission !== "granted") return false;
  try {
    new Notification(title, { body, tag, icon: "/favicon.ico", badge: "/favicon.ico" });
    return true;
  } catch {
    return false;
  }
}

// Full Web Push subscribe — registers SW, asks permission, subscribes, posts to backend.
// Returns {status: "granted" | "denied" | "unsupported" | "error"}
export async function subscribeToPush(bookingId) {
  if (!pushSupported()) return { status: "unsupported" };
  try {
    const perm = await requestNotificationPermission();
    if (perm !== "granted") return { status: perm };

    const registration = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;

    const { data } = await axios.get(`${API}/push/vapid-public`);
    if (!data.enabled || !data.public_key) return { status: "error" };

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
      });
    }

    const raw = subscription.toJSON();
    await axios.post(`${API}/push/subscribe`, {
      booking_id: bookingId,
      endpoint: raw.endpoint,
      keys: raw.keys,
    });
    return { status: "granted" };
  } catch (e) {
    console.error("Push subscribe failed:", e);
    return { status: "error" };
  }
}
